import { getPath } from '@/router/common'

const baseUrl = {
  title: '查看字典数据源',
  path: 'DataDictionary'
}

export default [
  {
    path: getPath('DataDictionaryDetail', baseUrl),
    name: 'DataDictionaryDetail',
    component: () =>
      import(
        /* webpackChunkName: "DataDictionaryDetail" */ '@/views/dataDictionary/dataDictionaryDetail/index.vue'
      ),
    meta: {
      title: '查看字典数据源'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'DataDictionary_Index',
    component: () =>
      import(
        /* webpackChunkName: "DataDictionary_Index" */ '@/views/dataDictionary/index/index.vue'
      ),
    meta: {
      title: '数据字典'
    }
  },
  {
    path: getPath('EditDataDictionary', baseUrl),
    name: 'DataDictionary_EditDataDictionary',
    component: () =>
      import(
        /* webpackChunkName: "DataDictionary_EditDataDictionary" */ '@/views/dataDictionary/editDataDictionary/index.vue'
      ),
    meta: {
      title: '数据字典新增修改'
    }
  }
]
